import { useTranslation } from 'react-i18next';
import { sentinel } from '@sentinel/ui';

const cardStyle: React.CSSProperties = {
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  gap: '1.25rem',
  alignItems: 'flex-start',
  flexWrap: 'wrap',
  padding: '1.5rem',
  borderRadius: '0.75rem',
  border: `1px solid ${sentinel.borderDefault}`,
  backgroundColor: sentinel.surfaceElevated,
  boxShadow: sentinel.shadowThin,
};

const iconChipStyle: React.CSSProperties = {
  flexShrink: 0,
  width: '3rem',
  height: '3rem',
  display: 'grid',
  placeItems: 'center',
  borderRadius: '0.625rem',
  color: sentinel.accentAction,
  backgroundColor: sentinel.surfaceOverlay,
  border: `1px solid ${sentinel.borderEmphasis}`,
};

const bodyStyle: React.CSSProperties = {
  flex: 1,
  minWidth: '16rem',
  display: 'grid',
  gap: '0.5rem',
};

const titleStyle: React.CSSProperties = {
  margin: 0,
  fontFamily: sentinel.fontDisplay,
  fontSize: '1.125rem',
  fontWeight: 600,
  letterSpacing: '-0.01em',
  color: sentinel.textBody,
};

const descStyle: React.CSSProperties = {
  margin: 0,
  fontFamily: sentinel.fontBody,
  fontSize: '0.9375rem',
  lineHeight: 1.55,
  color: sentinel.textMuted,
  maxWidth: '54ch',
};

const hintRowStyle: React.CSSProperties = {
  display: 'flex',
  gap: '0.5rem',
  alignItems: 'flex-start',
  marginBlockStart: '0.5rem',
  paddingBlockStart: '0.75rem',
  borderTop: `1px solid ${sentinel.borderDefault}`,
};

const hintIconStyle: React.CSSProperties = {
  flexShrink: 0,
  width: '1rem',
  height: '1rem',
  marginBlockStart: '0.15rem',
  color: sentinel.textSubtle,
};

const hintStyle: React.CSSProperties = {
  margin: 0,
  fontFamily: sentinel.fontBody,
  fontSize: '0.8125rem',
  lineHeight: 1.5,
  color: sentinel.textSubtle,
};

const lockGlyphStyle: React.CSSProperties = { width: '1.5rem', height: '1.5rem' };

function LockGlyph() {
  return (
    <svg
      style={lockGlyphStyle}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="4" y="10" width="16" height="11" rx="2" />
      <path d="M8 10V7a4 4 0 0 1 8 0v3" />
    </svg>
  );
}

function InfoGlyph() {
  return (
    <svg
      style={hintIconStyle}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v5M12 8h.01" />
    </svg>
  );
}

export function IdpManagedDeleteCard() {
  const { t } = useTranslation('data');
  return (
    <section style={cardStyle} data-testid="delete-idp-managed-card">
      <div style={iconChipStyle} aria-hidden="true">
        <LockGlyph />
      </div>
      <div style={bodyStyle}>
        <h2 style={titleStyle}>{t('delete_idp_managed_title')}</h2>
        <p style={descStyle}>{t('delete_idp_managed_body')}</p>
        <div style={hintRowStyle}>
          <InfoGlyph />
          <p style={hintStyle}>{t('delete_idp_managed_hint')}</p>
        </div>
      </div>
    </section>
  );
}
